import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowUp } from 'lucide-react';
export function MobileTopButton() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => setVisible(window.scrollY > 500);
    handleScroll();
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  if (!visible) return null;
  return <motion.button type="button" onClick={() => window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })} initial={{
    opacity: 0,
    scale: 0.8,
    y: 10
  }} animate={{
    opacity: 1,
    scale: 1,
    y: 0
  }} exit={{
    opacity: 0,
    scale: 0.8,
    y: 10
  }} whileTap={{
    scale: 0.9
  }} aria-label="Back to top" className="fixed bottom-20 right-4 z-40 inline-flex h-12 w-12 items-center justify-center rounded-full border border-pine/30 bg-cream text-pine shadow-lg shadow-pine/10 md:hidden" data-id="element-180" data-mp="j7yggk8a1qkl">
      <span className="absolute inset-1 rounded-full border border-ember/35" aria-hidden="true" data-id="element-181" data-mp="3f0e7ey1qktzo" />
      <ArrowUp className="relative h-5 w-5" data-id="element-182" data-mp="3a09pd3l6jr7c" />
    </motion.button>;
}